module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0092.jpg?v=597e2b70";